export const ServicesList = () => {
  const services = [
    {
      title: "Web Application Development",
      desc: "We build high-performance, scalable web applications tailored to your business needs. From startup MVPs to enterprise-grade platforms, our solutions are secure, fast, and user-focused.",
      points: ["Custom Dashboards", "Admin Panels", "SaaS Platforms", "API Integration"]
    },
    {
      title: "Mobile App Development",
      desc: "We create powerful Android and iOS apps with seamless performance and modern UI. Designed to engage users and drive business growth.",
      points: ["Cross-platform Apps", "Real-time Features", "Push Notifications", "App Store Deployment"]
    },
    {
      title: "UI/UX Design",
      desc: "We design intuitive, modern interfaces that enhance user experience and maximize conversion rates. Every design is crafted with usability in mind.",
      points: ["Wireframes", "Figma Design", "User Research", "Prototype Testing"]
    },
    {
      title: "AI & Machine Learning",
      desc: "We integrate intelligent systems to automate processes, analyze data, and build smart applications that improve efficiency.",
      points: ["Prediction Models", "Chatbots", "Data Analysis", "Automation"]
    },
    {
      title: "IoT Solutions",
      desc: "We develop IoT systems that connect devices, monitor real-time data, and automate workflows for smarter operations.",
      points: ["Sensor Integration", "Real-time Monitoring", "Cloud Sync", "Automation Systems"]
    },
  ];

  return (
    <section className="py-24">
      <h2 className="text-4xl font-bold text-center mb-14">
        Our Expertise
      </h2>

      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
        {services.map((s, i) => (
          <div key={i} className="p-8 border rounded-2xl hover:shadow-2xl transition">
            <h3 className="text-xl font-semibold mb-4">{s.title}</h3>
            <p className="text-gray-600 mb-4">{s.desc}</p>

            <ul className="text-sm text-gray-500 space-y-1">
              {s.points.map((p, idx) => (
                <li key={idx}>✔ {p}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};